const SERVICES = [
  {
    title: "Support Coordination",
    text: "Navigating your NDIS plan, connecting with trusted allied health providers, resolving service bottlenecks, and preparing for scheduled plan reviews.",
    foot: "Levels 1 & 2 Coordination available",
  },
  {
    title: "Personal Care & Daily Living",
    text: "Respectful assistance with morning routines, hygiene, meal preparation, mobility, medication reminders, and nighttime support.",
    foot: "Tailored daily schedules & consistent staff",
  },
  {
    title: "Community Access & Outings",
    text: "Assistance attending social groups, sports, medical appointments, shopping trips, hobbies, and exploring South Australian community events.",
    foot: "Transport & companion support included",
  },
  {
    title: "Respite & In-Home Support",
    text: "Giving primary family carers reliable rest while ensuring participants receive attentive, nurturing care in comfortable home environments.",
    foot: "Short-term, day, or overnight support",
  },
  {
    title: "Household Tasks & Domestic Help",
    text: "Full support with domestic duties: general cleaning, laundry, ironing, dishwashing, pantry organisation, changing linen, and garden maintenance to keep your home comfortable.",
    foot: "Any household tasks we can support and help",
    wide: true,
  },
];

export default function Services() {
  return (
    <section id="services" className="py-20 px-5 sm:px-8 bg-[#F6F1EA] border-t border-[#EAE3D8]" data-testid="services-section">
      <div className="max-w-6xl mx-auto space-y-12">
        <div className="max-w-2xl">
          <span className="text-xs uppercase tracking-widest text-[#786655] font-semibold">Core Services</span>
          <h2 className="text-3xl sm:text-4xl font-display font-medium text-[#1E282D] mt-2">Comprehensive NDIS support for every stage of your week</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s) => (
            <div key={s.title} data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={`p-6 rounded-2xl bg-[#FAF8F5] border border-[#E4DCCE] flex flex-col justify-between space-y-4 ${s.wide ? "md:col-span-2 lg:col-span-2" : ""}`}>
              <div>
                <h3 className="text-xl font-display font-medium text-[#1E282D]">{s.title}</h3>
                <p className="text-sm text-[#4E5B62] mt-2 leading-relaxed">{s.text}</p>
              </div>
              <p className="text-xs text-[#7B6E60] font-medium pt-2 border-t border-[#EFE8DF]">{s.foot}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
